export enum OrderStatusEnum {
  OPTION = 'OPTION',
  BOOKED = 'BOOKED',
}

export type OrderStatusEnumType = keyof typeof OrderStatusEnum;
